module.exports = __webpack_public_path__ + "static/assets/7b7fd92f837f3b1368bb7cd709b24ebd.svg";